import { doc, getDoc, setDoc } from 'firebase/firestore';

import { db } from '../firebase';
import { useSession } from '../session';
import { exportSave, importSave } from './idleStore';

let timer = null;
let lastJson = '';

const push = async (uid) => {
  const data = exportSave();
  const json = JSON.stringify(data);
  if (json === lastJson) return;
  lastJson = json;
  await setDoc(
    doc(db, 'users', uid),
    // idleTotalCoins is a flat number so a leaderboard query can sort on it
    { idleSave: data, idleTotalCoins: Math.floor(data.totalCoins) },
    { merge: true },
  );
};

export const startCloudSync = () => {
  useSession.subscribe((state, prev) => {
    const uid = state.user && state.user.uid;
    const prevUid = prev.user && prev.user.uid;
    if (uid === prevUid) return;

    clearInterval(timer);
    if (!uid) return;

    (async () => {
      try {
        const snap = await getDoc(doc(db, 'users', uid));
        const cloud = snap.exists() ? snap.data().idleSave : null;
        // Whichever side has earned more wins
        if (cloud && cloud.totalCoins > exportSave().totalCoins) importSave(cloud);
        await push(uid);
        timer = setInterval(() => push(uid).catch(() => {}), 30000);
      } catch (e) {
        console.error('Cloud save failed', e);
      }
    })();
  });
};